<template>
  <Content>
    <div class="md-layout container">
      <div class="md-layout-item md-size-50">
        <md-tabs>
        <md-tab id="tab-home" md-label="Home" md-icon="assignment_ind">
         <div class="md-card-perfil">
          <md-card-header>
            <div
              class="title-card"
            >
              {{ client.identification | mask(client.identification.length == 11 ? '###.###.###-##' : '##.###.###/####-##') }}
            </div>
          </md-card-header>
          <md-card-content>
            <div class="md-layout-item md-size-100">
              <md-field>
                <label>Nome Fantasia</label>
                <md-input
                  v-model="client.businessName"
                  readonly
                />
              </md-field>
              <md-field>
                <label>Razão Social</label>
                <md-input
                  v-model="client.name"
                  readonly
                />
              </md-field>
              <md-field>
                <label>E-mail para acesso sistema</label>
                <md-input
                  v-model="perfil.email"
                  placeholder="E-mail da Conta"/>
              </md-field>
              <md-field>
                <label>E-mail padrão para envio dos XMLs</label>
                <md-input
                  v-model="email"
                  placeholder="E-mail padrão para envio do XML"/>
              </md-field>
            </div>
            <md-button
              class="md-raised btn-atualizar-mail"
              @click="changeProfile()">Atualizar</md-button>
            <md-button
              class="md-raised md-primary"
              @click="modalAlterPassword = true">Alterar Senha</md-button>
          </md-card-content>
        </div>
      </md-tab>

      <md-tab id="tab-pages" md-label="Logomarca" md-icon="add_photo_alternate" style="height: 517px !important">
        <div class="md-card-perfil" v-if="image">
            <md-card-content>
              <div class="md-layout-item md-size-100">
                  <img class="preview" v-if="urlImage" :src="urlImage">
                  <img class="preview" v-else :src="previewImage">
              </div>
            </md-card-content>
            <div class="logo-info">Apenas imagens com até 2mb no formato .jpg e .png são aceitas</div>
            <md-button
                class="md-raised md-accent"
                @click="removeImage()">Remover
            </md-button>
        </div>        
        <div class="md-card-perfil-logo" v-else>
            <md-card-content>
              <div class="md-layout-item md-size-100">
                  <md-card-header>
                     <div class="logo-info">Nenhuma logomarca cadastrada</div>
                  </md-card-header>
              </div>
                <md-field>           
                   <input type="file" id="image" ref="image" v-on:change="handleFileUpload()"/>
              </md-field>
            </md-card-content>
        </div>
      </md-tab>
    </md-tabs>
  </div>

    <div
        v-show="modalAlterPassword"
        class="md-layout-item md-size-50">
        <div class="md-card-perfil">
          <md-card-header>
            <div class="title-card">Alteração de senha</div>
          </md-card-header>
          <md-card-content>
            <div class="md-layout-item md-size-100">
              <md-field>
                <label>Senha Atual</label>
                <md-input
                  v-model="oldPassword"
                  type="password"
                  placeholder="Senha Atual"/>
              </md-field>
              <md-field>
                <label>Nova Atual</label>
                <md-input
                  v-model="newPassword"
                  type="password"
                  placeholder="Nova Senha"/>
              </md-field>
              <md-field>
                <label>Senha Atual</label>
                <md-input
                  v-model="repeatPassword"
                  type="password"
                  placeholder="Repita a senha"/>
              </md-field>
              <div style="max-width: 300px">
                <password-strength-bar :password="newPassword" />
              </div>
            </div>
            <md-button
              class="md-raised md-primary"
              @click="changePasswd()">Alterar</md-button>
          </md-card-content>
        </div>
      </div>
    </div>
  </Content>
</template>
<script>
import { http } from '../../public/api/backend';
import Content from '../public/Content.vue';
import PasswordStrengthBar from '../../public/password/PasswordStrengthBar.vue'

export default {
  name: 'Perfil',
  components: {
    Content,
    PasswordStrengthBar
  },
  data() {
    return {
      client: [],
      perfil: [],
      modalAlterPassword: false,
      oldPassword: '',
      newPassword: '',
      repeatPassword: '',
      loadingPasswd: false,
      email: '',
      image: '',
      urlImage: '',
      hashImage: '',
    };
  },

  computed: {
    previewImage() {
      return  process.env.S3_IMAGE + this.image
    }
  },

  mounted() {
    this.getPerfil()
    this.getClient()
  },
  methods: {

    getPerfil() {
      http.post('application.get-profile')
        .then(response => {
          this.perfil = response.data
        })
    },

    getClient() {
      http.post('application.get-client')
        .then(response => {
          this.client = response.data
          this.email = response.data.emailInvoice
          this.image =  response.data.image
        })
    },

    changeProfile() {
      swal({
        title: 'Deseja alterar os dados?',
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Cancelar',
            value: 'cancel',
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: 'OK',
            visible: true,
            closeModal: false
          }
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      })
        .then((value) => {
          if (value === 'cancel') {
            swal.stopLoading()
            swal.close()
            return
          }
          if (this.email !== this.client.emailInvoice) {
            this.changeClient()
          }

          if (this.image) {
            this.uploadLogo()
          }
          
          http.post('application.put-profile', {
              id: this.perfil.id,
              name: this.perfil.name,
              email: this.perfil.email,
              allowResellerAccess: this.perfil.allowResellerAccess,
            })
            .then(() => {
              this.$toasted.show('Dados alterados com sucesso!', {
                theme: 'outline',
                position: 'bottom-right',
                duration: 5000,
                type: 'success',
                icon: 'check_circle'
              });
              swal.stopLoading()
              swal.close()
            })
            .catch(() => {
              this.$toasted.show('Não foi possível atualizar os dados', {
                theme: 'outline',
                position: 'bottom-right',
                duration: 5000,
                type: 'error',
                icon: 'error_outline'
              });
            })
        });
    },

    changeClient() {
      http.post('application.put-client', {
          id: this.client.id,
          emailInvoice: this.email,
          name: this.client.name,
          email: this.client.email,
          identification: this.client.identification,
          serial: this.client.serial,
        })
        .catch(() => {
          this.$toasted.show('Não foi possível atualizar os dados', {
            theme: 'outline',
            position: 'bottom-right',
            duration: 5000,
            type: 'error',
            icon: 'error_outline'
          });
        })
    },

    changePasswd() {
      if (this.newPassword !== this.repeatPassword) {
        this.$toasted.show('As senhas não conferem, verifique!', {
          theme: 'outline',
          position: 'bottom-right',
          duration: 5000,
          type: 'error',
          icon: 'error_outline'
        });
        this.loadingPasswd = false;
      }
      http.post('application.change-passwd', {
          new_password: this.newPassword,
          old_password: this.oldPassword,
        })
        .then(() => {
          this.$toasted.show('Senha alterada com sucesso!', {
            theme: 'outline',
            position: 'bottom-right',
            duration: 5000,
            type: 'success',
            icon: 'check_circle'
          });
          this.resetFields()
        })
        .catch(error => {
          this.$toasted.show(error.response.data.error_message, {
            theme: 'outline',
            position: 'bottom-right',
            duration: 5000,
            type: 'error',
            icon: 'error_outline'
          });
        })
    },

    resetFields() {
      this.newPassword = '';
      this.oldPassword = '';
      this.repeatPassword = '';
      this.modalAlterPassword = false;
    },

    handleFileUpload() {
        const file = this.$refs.image.files[0];
        this.urlImage = URL.createObjectURL(file);
        this.image = this.$refs.image.files[0];
    },


    uploadLogo() {
      const defaultSize = 1080;
      var data = new FormData();
      data.append('image', this.image);
      data.append('maxWidth', defaultSize);
      data.append('maxHeight', defaultSize);
      
      http.post('core.upload-image', data, {
          headers: {
            'Content-Type': 'multipart/form-data;'
         }
        })
        .then(response => {
            this.hashImage = response.data['hash-image']
            this.changeLogoClient()
        })
        .catch(error => {
            this.$toasted.show('Não foi possível atualizar a logo', {
              theme: 'outline',
              position: 'bottom-right',
              duration: 5000,
              type: 'error',
              icon: 'error_outline'
            });
        })
    },

    changeLogoClient() {
      http.post('application.put-client', {
          id: this.client.id,
          name: this.client.name,
          email: this.client.email,
          identification: this.client.identification,
          image: this.hashImage,
          serial: this.client.serial,
        })
        .catch(() => {
          this.$toasted.show('Não foi possível atualizar os dados', {
            theme: 'outline',
            position: 'bottom-right',
            duration: 5000,
            type: 'error',
            icon: 'error_outline'
          });
        })
    },

    removeImage() {
      this.image = ''
      this.urlImage = ''
      this.changeLogoClient()      
    }
  },
};
</script>

<style type="text/css">
.preview {
  display: flex;
  justify-content: center;
  align-items: center;
}

.img {
  max-width: 100%;
  max-height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/client/perfil/Perfil.vue